angular.module('LeasePilot').directive('downloadLease', [
  'DocumentService',
  '$rootScope',
  '$filter',
  'ApiService',
  'LeaseEditorService',
  'ProcessStatusService',
  'DownloadService',
  '$mdDialog',
  'leaseExportService',
  function(
    DocumentService,
    $rootScope,
    $filter,
    ApiService,
    LeaseEditorService,
    ProcessStatusService,
    DownloadService,
    $mdDialog,
    leaseExportService,
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'download_lease.html',
      link: function($scope) {
        $scope.processing = false;
        $scope.eventName = 'downloadLease';
        var type =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        $scope.downloadErrorMessage =
          'Oops... something went wrong with the download process, please wait a couple of seconds and try again.';

        var iframe = angular.element('<iframe/>', {
          id: 'download-lease',
          name: 'download',
          style:
            'position: absolute; top: 0; left: 0; width: 1px; height: 1px; z-index: -1; opacity: 0;',
          'event-name': $scope.eventName,
        });

        /**
         * lp-015. Said on the way out, not in the way.
         *
         * The download is never blocked: a drafter downloads for a dozen
         * reasons that are not sending it to a counterparty, and a checker that
         * stands between somebody and their own document is a checker that gets
         * switched off. But leaving in silence is the one moment where saying
         * nothing is itself a choice.
         *
         * A dialog rather than a toast, because this is the one notice in the
         * feature that is worth interrupting for, and because a message that
         * fades after five seconds cannot offer a way to act on itself. The
         * download has already started by the time it is read; the only thing
         * being asked is whether to go and look.
         */
        function noticeUnreviewedFindings() {
          const checks = $rootScope.checks;
          if (!checks || !checks.total) return;

          const headline =
            checks.total === 1
              ? 'One finding is still open'
              : `${checks.total} findings are still open`;

          const serious = checks.high
            ? checks.high === 1
              ? ' One of them is high.'
              : ` ${checks.high} of them are high.`
            : '';

          $mdDialog
            .show({
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              escapeToClose: true,
              fullscreen: false,
              locals: { headline: headline, serious: serious, checks: checks },
              controller: [
                '$scope',
                '$mdDialog',
                'headline',
                'serious',
                'checks',
                function(dialogScope, dialog, headlineText, seriousText, summary) {
                  dialogScope.headline = headlineText;
                  dialogScope.serious = seriousText;
                  dialogScope.isSerious = Boolean(summary.high);
                  dialogScope.showMe = function() {
                    dialog.hide();
                  };
                  dialogScope.notNow = function() {
                    dialog.cancel();
                  };
                },
              ],
              template: [
                '<md-dialog class="checks-dialog" aria-label="Open findings">',
                '  <div class="checks-dialog__body">',
                '    <span class="checks-dialog__mark"',
                '      ng-class="{ \'checks-dialog__mark--serious\': isSerious }">',
                '      <svg viewBox="0 0 18 18" fill="none" aria-hidden="true">',
                '        <path d="M4 2.5h7.5L15 6v9.5H4V2.5Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>',
                '        <path d="M11 2.5V6h3.5" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>',
                '        <path d="M6.4 10.2 8 11.8l3.4-3.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>',
                '      </svg>',
                '    </span>',
                '    <div>',
                '      <h2 class="checks-dialog__title">{{ headline }}</h2>',
                '      <p class="checks-dialog__text">',
                '        Your download has started.{{ serious }} Worth a look before this',
                '        document goes to anyone.',
                '      </p>',
                '    </div>',
                '  </div>',
                '  <div class="checks-dialog__acts">',
                '    <button class="btn blue-outline" type="button" ng-click="notNow()">Not now</button>',
                '    <button class="btn blue" type="button" ng-click="showMe()">Show me</button>',
                '  </div>',
                '</md-dialog>',
              ].join('\n'),
            })
            .then(showChecks, angular.noop);
        }

        function showChecks() {
          // Only if it is not already the pane on screen — `toggleLeftPane`
          // does what its name says, and closing the panel is the opposite of
          // what "Show me" promised.
          if ($scope.leftPane !== 'checks') $scope.toggleLeftPane('checks');
        }

        $scope.downloadDocument = function() {
          window.track.event(new DownloadDocumentEvent({
            context: $rootScope.getContext(),
          }));

          // lp-015. The moment the document's blanks stop being fields.
          //
          // Before this, a lease is a projection of its form and the checks
          // hold their tongue. This arms them, and it must run BEFORE the
          // notice: `$broadcast` is synchronous, so the mechanical pass has
          // published by the time `noticeUnreviewedFindings` reads the summary.
          $rootScope.$broadcast('lp:document-sent');
          noticeUnreviewedFindings();
          $scope.processing = true;
          ProcessStatusService.start("download");
          if (window.lease) {
            downloadManager.prepareDownload("downloadLease");
          } else {
            var src =
              "/" +
              pluralize($rootScope.lease.type).toLowerCase() +
              "/" +
              $rootScope.lease.id;
            angular
              .element('iframe[event-name="' + $scope.eventName + '"]')
              .remove();
            angular.element(iframe).attr("src", src);
            angular.element("body").append(iframe);
          }
        };

        $scope.downloadSubdocument = function(subdocumentName) {
          window.track.event(new DownloadDocumentEvent({
            context: $rootScope.getContext(),
          }));

          $scope.processing = true;
          ProcessStatusService.start("download");
          if (window.lease) {
            const startNode = document.querySelector(`subdocument[name='${subdocumentName}']`);
            const endNode = document.querySelector(`subdocument-end[name='${subdocumentName}']`);
            const filename = startNode.getAttribute("filename");
            downloadManager.downloadSubdocument(subdocumentName, filename);
          } else {
            var src =
              "/" +
              pluralize($rootScope.lease.type).toLowerCase() +
              "/" +
              $rootScope.lease.id;
            angular
              .element('iframe[event-name="' + $scope.eventName + '"]')
              .remove();
            angular.element(iframe).attr("src", src);
            angular.element("body").append(iframe);
          }
        };

        $scope.$on($scope.eventName, function(event, data) {   
          $scope.processing = true;
          ProcessStatusService.start("download");
          $scope.safeApply();
          
          console.log(new Date().getTime() + ' on event: ', $scope.eventName);
          console.log(new Date().getTime() + ' data ', data);

          ////////////////////////////////////////////////
          // PLEASE KEEP COMMENT IN PLACE - this used for document conversion testing purposes [Itzik S]
          // DownloadService.download(data.file, "html/text", "input_document.html");
          ////////////////////////////////////////////////

          ApiService.htmlToWord(data.file, window.ASSETS_DESIRED_STYLES)
            .then(function successCallback(response) {
              $scope.processing = false;
              ProcessStatusService.end('download');
              $scope.safeApply();
              DownloadService.download(response.data, type, LeaseEditorService.getFileName());
              console.log(
                new Date().getTime() + ' download lease finished successfully',
              );

              // Trigger update status - it'll only update the status if necessary
              updateStatus();
            },
            function errorCallback(response) {
              $scope.processing = false;
              ProcessStatusService.end('download');
              $scope.safeApply();
              console.log(response);
              alert($scope.downloadErrorMessage);
            },
          );
        });

        function updateStatus() {
          if (window.user.company.name === 'kite') {
            const statusPickerElement = document.querySelector('status-picker');
            const statusPickerScope = angular.element(statusPickerElement.firstElementChild).scope();
  
            if (statusPickerScope.exportStatusId) {
              statusPickerScope.selectStatus(statusPickerScope.exportStatusId);
            }
          }
        }
      },
    };
  },
]);
